 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLE from '@/components/Text/Title'
 import TEXTCOPYRIGHT from '@/components/Text/Copyright'
 import TEXTDEDICATION from '@/components/Text/Dedication'
 import TEXTCONTENTS from '@/components/Text/Contents'
 import TEXTINTRODUCTION from '@/components/Text/Introduction'
 import TEXTPROLOGUE from '@/components/Text/Prologue'
 import TEXTI from '@/components/Text/I'
 import TEXT1 from '@/components/Text/1'
 import TEXT2 from '@/components/Text/2'
 import TEXTII from '@/components/Text/II'
 import TEXT3 from '@/components/Text/3'
 import TEXT4 from '@/components/Text/4'
 import TEXT5 from '@/components/Text/5'
 import TEXTIII from '@/components/Text/III'
 import TEXT6 from '@/components/Text/6'
 import TEXT7 from '@/components/Text/7'
 import TEXT8 from '@/components/Text/8'
 import TEXT9 from '@/components/Text/9'
 import TEXTIV from '@/components/Text/IV'
 import TEXT10 from '@/components/Text/10'
 import TEXT11 from '@/components/Text/11'
 import TEXT12 from '@/components/Text/12'
 import TEXT13 from '@/components/Text/13'
 import TEXTV from '@/components/Text/V'
 import TEXT14 from '@/components/Text/14'
 import TEXT15 from '@/components/Text/15'
 import TEXTEPILOGUE from '@/components/Text/Epilogue'
 import LOVE_2 from '@/components/love_2'
 import TEXTENDNOTES from '@/components/Text/Endnotes'
 import TEXTACKNOWLEDGMENTS from '@/components/Text/Acknowledgments'
 import TEXTINDEX from '@/components/Text/Index'
 import TEXTAUTHORS from '@/components/Text/Authors'
 import TEXTSECTION0001 from '@/components/Text/Section0001'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/Contents",
 			"name" : "Text/Contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/Introduction",
 			"name" : "Text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/Text/Prologue",
 			"name" : "Text/Prologue",
 			"component" : TEXTPROLOGUE
 		},
 		{
 			"path" : "/Text/I",
 			"name" : "Text/I",
 			"component" : TEXTI
 		},
 		{
 			"path" : "/Text/1",
 			"name" : "Text/1",
 			"component" : TEXT1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js